/** TanStack Query mutation hooks for step media: upload and delete. */
import { useMutation } from '@tanstack/react-query';
import { api } from '@/shared/api/client';

// ─── Types ───────────────────────────────────────────────────────────────────

/** Response shape from POST /steps/media. */
export interface StepMediaUploadResult {
  mediaId: string;
  path: string;
  url: string;
  type: 'image' | 'video' | 'audio';
  filename: string;
  size: number;
  mimeType: string;
}

// ─── Mutations ───────────────────────────────────────────────────────────────

/** Upload a media file for a step. Posts multipart/form-data to POST /steps/media. */
export function useUploadStepMedia() {
  return useMutation({
    mutationFn: ({ stepId, file }: { stepId: string; file: File }) => {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('stepId', stepId);
      return api.post<StepMediaUploadResult>('/steps/media', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    },
  });
}

/** Delete a media file from a step. Calls DELETE /steps/media. */
export function useDeleteStepMedia() {
  return useMutation({
    mutationFn: ({ stepId, filename }: { stepId: string; filename: string }) =>
      api.del('/steps/media', { data: { stepId, filename } }),
  });
}
